/**
 * Not-found route (APP-001 §6, APP-009 §25).
 *
 * A single, unauthenticated 404 surface. Signed-in users get a way back to the
 * dashboard; everyone gets documentation and support links. No route internals
 * are exposed.
 */
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@clerk/clerk-react';
import { getAppLinks } from '@/config/links';

export function NotFoundRoute() {
  const { isSignedIn } = useAuth();
  const links = getAppLinks();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-6 text-center">
      <p className="text-sm font-medium text-primary">404</p>
      <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        The page you are looking for does not exist or may have moved.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button asChild>
          <Link to={isSignedIn ? '/dashboard' : '/sign-in'}>
            Go {isSignedIn ? 'to dashboard' : 'to sign in'}
          </Link>
        </Button>
        <Button variant="outline" asChild>
          <a href={links.apiDocs} target="_blank" rel="noopener noreferrer">
            API documentation
          </a>
        </Button>
        <Button variant="outline" asChild>
          <a href={links.support} target="_blank" rel="noopener noreferrer">
            Contact support
          </a>
        </Button>
      </div>
    </div>
  );
}
